import React from 'react'
import { SyndicationContext } from '../SyndicationContext'

export function useIsSyndicatedComponent() {
    return React.useContext(SyndicationContext) === true
}
